import { Component, Input } from '@angular/core';
import { ProgressbarConfig } from './progressbar.config';


export class ProgressbarComponent {
  /** if `true` changing value of progress bar will be animated (note: not supported by Bootstrap 4) */
   public animate:boolean;
  /** maximum total value of progress element */
   public max:number;
  /** provide one of the four supported contextual classes: `success`, `info`, `warning`, `danger` */
   public type:string;
  /** current value of progress bar */
   public value:number;

  public constructor(config: ProgressbarConfig) {
    Object.assign(this, config);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'progressbar',
  template: `
    <div progress [animate]="animate" [max]="max">
      <bar [type]="type" [value]="value">
          <ng-content></ng-content>
      </bar>
    </div>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ProgressbarConfig, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'animate': [{ type: Input },],
'max': [{ type: Input },],
'type': [{ type: Input },],
'value': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
